<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        :disabled="!formValid"
        @cancel="close()"
        @submit="mode === 1 ? create() : update()"
        :submit-text="{ el: 'Προσθήκη', en: 'Save', it: 'Aggiungi' }"
        :cancel-text="{ el: 'Κλείσιμο', en: 'Cancel', it: 'Chiudi' }"
    >
        <b-select
            v-model="couponOnProduct.gift_category_id"
            :items="giftCategories"
            :item-text="`name[${lang}]`"
            item-value="gift_category_id"
            :label="translations.giftCategory[lang]"
            no-top-margin
            :success="success.giftCategory"
            :error-messages="error.giftCategory"
            @focus="error.giftCategory = ''"
            @blur="validateGiftCategory"
        ></b-select>

        <v-radio-group
            v-model="couponOnProduct.action"
            class="mt-3 pa-5 b-outlined rounded"
            hide-details="auto"
            :readonly="mode === 2"
            :class="{ 'not-allowed': mode === 2 }"
        >
            <v-row no-gutters>
                <v-col
                    v-for="type in actionTypes"
                    :key="type.text['en']"
                    cols="6"
                >
                    <v-radio color="secondary" :value="type.value">
                        <template v-slot:label>
                            <h4
                                class="subtitle-2"
                                v-text="type.text[lang]"
                            ></h4>
                        </template>
                    </v-radio>
                </v-col>
            </v-row>
        </v-radio-group>

        <div
            class="subtitle-2 text--secondary mt-3"
            v-text="translations.info[lang]"
        ></div>

        <v-row v-if="couponOnProduct.action === '1p1'" no-gutters>
            <v-col cols="6" class="pr-2">
                <v-menu
                    v-model="saleMenu"
                    max-height="300"
                    offset-y
                    :close-on-content-click="false"
                    nudge-bottom="3"
                    @blur="validateSaleProduct"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="saleSearch"
                            ref="search"
                            :label="translations.productForSale[lang]"
                            color="secondary"
                            outlined
                            dense
                            clearable
                            v-on="on"
                            hide-details="auto"
                            autocomplete="off"
                            :append-icon="
                                saleMenu ? icons.mdiMenuUp : icons.mdiMenuDown
                            "
                            :loading="saleProductsLoading"
                            :success="success.saleProduct"
                            :error-messages="error.saleProduct"
                            @focus="error.saleProduct = ''"
                            @click:append="
                                () => {
                                    saleMenu = !saleMenu;
                                    $refs.search.focus();
                                }
                            "
                        ></v-text-field>
                    </template>

                    <v-list dense>
                        <template v-if="saleProducts.length">
                            <v-list-item
                                v-for="product in saleProducts"
                                :key="product.product_id"
                                class="pl-3"
                                @click="
                                    () => {
                                        couponOnProduct.product_buy_id =
                                            product.product_id;
                                        saleSearch = product.name[lang];
                                        saleMenu = false;
                                    }
                                "
                            >
                                <v-list-item-title>
                                    <v-row no-gutters justify="space-between">
                                        <v-col cols="auto">
                                            {{ product.name[lang] }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <v-list-item v-else>
                            <v-list-item-title
                                v-text="'No Data'"
                            ></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="6" class="pl-2">
                <v-menu
                    v-model="giftMenu"
                    max-height="300"
                    offset-y
                    :close-on-content-click="false"
                    nudge-bottom="3"
                    @blur="validateGiftProduct"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="giftSearch"
                            ref="search"
                            :label="translations.productForGift[lang]"
                            color="secondary"
                            outlined
                            dense
                            clearable
                            v-on="on"
                            hide-details="auto"
                            autocomplete="off"
                            :append-icon="
                                giftMenu ? icons.mdiMenuUp : icons.mdiMenuDown
                            "
                            :loading="giftProductsLoading"
                            :success="success.giftProduct"
                            :error-messages="error.giftProduct"
                            @focus="error.giftProduct = ''"
                            @click:append="
                                () => {
                                    giftMenu = !giftMenu;
                                    $refs.search.focus();
                                }
                            "
                        ></v-text-field>
                    </template>

                    <v-list dense>
                        <template v-if="giftProducts.length">
                            <v-list-item
                                v-for="product in giftProducts"
                                :key="product.product_id"
                                class="pl-3"
                                @click="
                                    () => {
                                        couponOnProduct.product_free_id =
                                            product.product_id;
                                        giftSearch = product.name[lang];
                                        giftMenu = false;
                                    }
                                "
                            >
                                <v-list-item-title>
                                    <v-row no-gutters justify="space-between">
                                        <v-col cols="auto">
                                            {{ product.name[lang] }}
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                        <v-list-item v-else>
                            <v-list-item-title
                                v-text="'No Data'"
                            ></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>

        <!-- <b-select
            v-else
            v-model="couponOnProduct.product_free_id"
            :items="saleProducts"
            :item-text="`name[${lang}]`"
            item-value="product_id"
            :label="translations.productForGift[lang]"
            :success="success.giftProduct"
            :error-messages="error.giftProduct"
            @focus="error.giftProduct = ''"
            @blur="validateGiftProduct"
        ></b-select> -->

        <v-menu
            v-else
            v-model="menu"
            max-height="300"
            offset-y
            :close-on-content-click="false"
            nudge-bottom="3"
            @blur="validateGiftProduct"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="search"
                    ref="search"
                    :label="translations.productForGift[lang]"
                    color="secondary"
                    outlined
                    dense
                    clearable
                    v-on="on"
                    hide-details="auto"
                    autocomplete="off"
                    :append-icon="menu ? icons.mdiMenuUp : icons.mdiMenuDown"
                    :loading="productsLoading"
                    :success="success.giftProduct"
                    :error-messages="error.giftProduct"
                    @focus="error.giftProduct = ''"
                    @click:append="
                        () => {
                            menu = !saleMenu;
                            $refs.search.focus();
                        }
                    "
                ></v-text-field>
            </template>

            <v-list dense>
                <template v-if="products.length">
                    <v-list-item
                        v-for="product in products"
                        :key="product.product_id"
                        class="pl-3"
                        @click="
                            () => {
                                couponOnProduct.product_free_id =
                                    product.product_id;
                                search = product.name[lang];
                                menu = false;
                            }
                        "
                    >
                        <v-list-item-title>
                            <v-row no-gutters justify="space-between">
                                <v-col cols="auto">
                                    {{ product.name[lang] }}
                                </v-col>
                            </v-row>
                        </v-list-item-title>
                    </v-list-item>
                </template>
                <v-list-item v-else>
                    <v-list-item-title v-text="'No Data'"></v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <b-text-field
            v-model="couponOnProduct.maximum"
            :label="translations.totalCoupons[lang]"
            type="number"
            :success="success.totalCoupons"
            :error-messages="error.totalCoupons"
            @focus="error.totalCoupons = ''"
            @blur="validateTotalCoupons"
        ></b-text-field>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/storePanel/coupons/couponsOnProducts/couponOnProduct";
import validators from "@/utils/validators/storePanel/couponOnProduct";
import debounce from "lodash/debounce";
import { mdiMenuUp, mdiMenuDown } from "@mdi/js";

export default {
    name: "CouponOnProductForm",

    props: {
        mode: Number,
    },

    mixins: [translations, validators],

    data() {
        return {
            icons: {
                mdiMenuUp,
                mdiMenuDown,
            },
            actionTypes: [
                {
                    text: {
                        el: "1+1 Δώρο",
                        en: "Buy one, Get one free",
                        it: "Prendi due, Paghi uno",
                    },
                    value: "1p1",
                },
                {
                    text: { el: "Δείγμα", en: "Sample", it: "Campione" },
                    value: "sample",
                },
            ],
            menu: false,
            search: "",
            saleMenu: false,
            saleSearch: "",
            giftMenu: false,
            giftSearch: "",
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),
        ...mapState("storePanel/coupons/couponsOnProducts", [
            "giftCategories",
            "products",
            "productsLoading",
            "saleProducts",
            "saleProductsLoading",
            "giftProducts",
            "giftProductsLoading",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 1
                ? this.translations.newAction[this.lang]
                : this.translations.updateAction[this.lang];
        },

        couponOnProduct: {
            get() {
                return this.$store.state.storePanel.coupons.couponsOnProducts
                    .couponOnProduct;
            },
            set(val) {
                this.setItem(val);
            },
        },
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapMutations("storePanel/coupons/couponsOnProducts", ["setItem"]),
        ...mapActions("storePanel/coupons/couponsOnProducts", [
            "getGiftCategories",
            "getProducts",
            "getSaleProducts",
            "getGiftProducts",
            "create",
            "update",
        ]),

        handleSaleSearch() {
            this.getSaleProducts(`?q=${this.saleSearch}`);
        },

        handleGiftSearch() {
            this.getGiftProducts(`?q=${this.giftSearch}`);
        },

        handleSearch() {
            this.getProducts(`?q=${this.search}`);
        },

        close() {
            this.getProducts(`?page=1`);
            this.getSaleProducts(`?page=1`);
            this.getGiftProducts(`?page=1`);
            this.saleSearch = "";
            this.giftSearch = "";
            this.search = "";
            this.couponOnProduct = {};
            this.$emit("cancel");
        },
    },

    watch: {
        search(val) {
            this.menu = true;
            if (val) {
                this.debouncedSearch();
            } else {
                this.getProducts(`?page=1`);
                this.couponOnProduct.product_free_id = null;
            }
        },
        saleSearch(val) {
            this.menu = true;
            if (val) {
                this.debouncedSaleSearch();
            } else {
                this.getSaleProducts(`?page=1`);
                this.couponOnProduct.product_buy_id = null;
            }
        },

        giftSearch(val) {
            this.menu = true;
            if (val) {
                this.debouncedGiftSearch();
            } else {
                this.getGiftProducts(`?page=1`);
                this.couponOnProduct.product_free_id = null;
            }
        },
    },

    mounted() {
        this.getGiftCategories();
        this.getProducts(`?page=1`);
        this.getSaleProducts(`?page=1`);
        this.getGiftProducts(`?page=1`);
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
        this.debouncedSaleSearch = debounce(this.handleSaleSearch, 500);
        this.debouncedGiftSearch = debounce(this.handleGiftSearch, 500);
    },
};
</script>

<style>
.not-allowed input {
    cursor: not-allowed;
}

.not-allowed .v-input--selection-controls__ripple {
    cursor: not-allowed;
}
</style>
